/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { RadioButton } from '@components/common';
import { makeSelectTranslationWizardAdditionalReports } from '@modules/internationalization/intSelectors';
import { IWizardAdditionalReportsTranslation } from '@modules/internationalization/types/wizards/additionalReports';
import {
    WizardAdditionalReportsStepChooseStyled,
} from '@pages/WizardAdditionalReports/components/styled/WizardAdditionalReportsStyled';
import {
    EWizardAdditionalReportsSteps,
} from '@pages/WizardAdditionalReports/wizardAdditionalReportsConsant';
import {
    makeSelectWizardAdditionalReportsIsStepValid, makeSelectWizardAdditionalReportsParam,
} from '@pages/WizardAdditionalReports/wizardAdditionalReportsSelectors';
import { IRootReducer } from '@reducers/rootReducer';

import { TWizardAdditionalReportsSetParamsPayload } from '../types/wizardAdditionalReportsActionTypes';
import { wizardAdditionalReportsSetParamsAction } from '../wizardAdditionalReportsActions';
import { IWizardAdditionalReportsReducer } from '../wizardAdditionalReportsReducer';

const WizardAdditionalReportsStepChoose = ({
                                               reportsTypes,
                                               chosenReport,
                                               setParams,
                                               translation,
                                           }: IConnectedProps & IDispatchProps) => {
    const stepTranslation = translation[EWizardAdditionalReportsSteps.ChooseStep];

    return (
        <WizardAdditionalReportsStepChooseStyled>
            <div className="wizard-additional-reports__title">
                {stepTranslation.chooseReport}
            </div>
            {reportsTypes.map((el) => {
                return (
                    <div className="wizard-additional-reports__group-control">
                        <RadioButton
                            checked={chosenReport === el}
                            dataName={`wizard-additional-reports-type-${el}`}
                            label={translation.reports[el]}
                            onChange={() => setParams({ chosenReport: el })}
                        />
                    </div>
                );
            })}
        </WizardAdditionalReportsStepChooseStyled>
    );
};

type TParams = Pick<IWizardAdditionalReportsReducer, 'reportsTypes'|'isStepValid'|'chosenReport'>;

export interface IConnectedProps extends TParams {
    translation: IWizardAdditionalReportsTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    reportsTypes: makeSelectWizardAdditionalReportsParam('reportsTypes'),
    chosenReport: makeSelectWizardAdditionalReportsParam('chosenReport'),
    isStepValid: makeSelectWizardAdditionalReportsIsStepValid(),
    translation: makeSelectTranslationWizardAdditionalReports(),
});

export interface IDispatchProps {
    setParams: (payload: TWizardAdditionalReportsSetParamsPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    setParams: payload => dispatch(wizardAdditionalReportsSetParamsAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardAdditionalReportsStepChoose);
